/*!
 * Solva — Header behaviours
 * - Mobile drawer (burger open / close / esc / outside-click / focus-trap)
 * - Sticky on scroll: adds .is-sticky-active after threshold
 * - Search panel toggle
 * - Live cart count refresh via Shopify /cart.js (best-effort)
 */
(function () {
  if (typeof document === 'undefined') return;

  document.querySelectorAll('solva-header').forEach(function (root) {

    // ---------- Drawer ----------
    var burger   = root.querySelector('[data-solva-burger]');
    var drawer   = root.querySelector('[data-solva-drawer]');
    var drawerBg = root.querySelector('[data-solva-drawer-bg]');
    var closeBtn = root.querySelector('[data-solva-drawer-close]');

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false; drawerBg.hidden = false;
      // next frame to allow transition
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        drawerBg.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      burger && burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      // focus first link
      var firstLink = drawer.querySelector('a, button');
      firstLink && firstLink.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawerBg.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger && burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      // hide after transition
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true; drawerBg.hidden = true;
        }
      }, 280);
      burger && burger.focus();
    }

    burger   && burger.addEventListener('click', openDrawer);
    closeBtn && closeBtn.addEventListener('click', closeDrawer);
    drawerBg && drawerBg.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    // ---------- Search panel ----------
    var searchToggle = root.querySelector('[data-solva-search-toggle]');
    var searchPanel  = root.querySelector('[data-solva-search]');
    var searchClose  = root.querySelector('[data-solva-search-close]');

    function toggleSearch(force) {
      if (!searchPanel) return;
      var willOpen = (typeof force === 'boolean') ? force : searchPanel.hidden;
      searchPanel.hidden = !willOpen;
      searchToggle && searchToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var input = searchPanel.querySelector('input[type="search"]');
        input && input.focus();
      } else {
        searchToggle && searchToggle.focus();
      }
    }
    searchToggle && searchToggle.addEventListener('click', function () { toggleSearch(); });
    searchClose  && searchClose.addEventListener('click', function () { toggleSearch(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchPanel && !searchPanel.hidden) toggleSearch(false);
    });

    // ---------- Sticky on scroll ----------
    if (root.getAttribute('data-sticky') === 'true') {
      var threshold = 24;
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          root.classList.toggle('is-sticky-active', window.scrollY > threshold);
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // ---------- Live cart-count refresh ----------
    // Fetch the latest cart on page-load + whenever a click on the same page
    // results in an item being added. Best-effort, silent on failure.
    var countEl = root.querySelector('[data-solva-cart-count]');
    function refreshCart() {
      if (!countEl) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          countEl.textContent = cart.item_count;
          countEl.classList.toggle('is-visible', cart.item_count > 0);
        })
        .catch(function () {});
    }
    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('cart:added',   refreshCart);
    // Refresh on document-ready in case the rendered count is stale
    refreshCart();
  });
})();
